import { styled } from '@mui/material/styles';

export const StyledCheckboxControlIcon = styled('span')(({ theme }) => ({
  boxSizing: 'border-box',
  borderRadius: 2,
  width: 22,
  height: 22,
  backgroundColor: theme.palette.neutral[0],
  border: `2px solid ${theme.palette.neutral[200]}`,
  'input:disabled ~ &': {
    backgroundColor: theme.palette.neutral[100],
  },
}));

export const StyledCheckboxControlCheckedIcon = styled(
  StyledCheckboxControlIcon,
)(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.brandSecondary.mainCustom,
  borderColor: theme.palette.brandSecondary.mainCustom,
  'input:disabled ~ &': {
    backgroundColor: theme.palette.neutral[200],
    borderColor: theme.palette.neutral[200],
  },
  '&:before, &:after': {
    content: '""',
    position: 'absolute',
    left: 0,
    bottom: 4,
    backgroundColor: theme.palette.neutral[0],
    transform: 'translateX(8px) rotate(-45deg)',
    transformOrigin: 'left bottom',
  },
  '&:before': {
    height: 7,
    width: 2,
  },
  '&:after': {
    height: 2,
    width: 12,
  },
}));
